import React from "react"

const VideoGrid = ({ children }) => (
  <div className="grid grid-cols-2 gap-4 md:gap-6 md:grid-cols-3 lg:grid-cols-4">
    {children}
  </div>
)

export default VideoGrid
